import React, { useState } from 'react';
import { TextField, Autocomplete, Select, MenuItem, InputLabel, FormControl, FormGroup, Typography, Box, Divider } from '@mui/material';
import './sponsorForm.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const therapeuticAreas = [
  { title: 'Cardiology' },
  { title: 'Oncology' },
  { title: 'Neurology' },
  { title: 'Dermatology' },
  { title: 'Endocrinology' },
  { title: 'Gastroenterology' },
  { title: 'Hematology' },
  { title: 'Immunology' },
  { title: 'Infectious Diseases' },
  { title: 'Nephrology' },
  { title: 'Ophthalmology' },
  { title: 'Orthopedics' },
  { title: 'Pulmonology' },
  { title: 'Rheumatology' },
  { title: 'Urology' },
  { title: 'Psychiatry' },
  { title: 'Pediatrics' },
  { title: 'Obstetrics and Gynecology' },
  { title: 'Otorhinolaryngology' },
  { title: 'Radiology' },
  { title: 'Allergy and Immunology' },
  { title: 'Clinical Pharmacology' },
  { title: 'Medical Genetics' },
  { title: 'Neonatology' },
  { title: 'Nutrition' },
  { title: 'Oncology Surgery' },
  { title: 'Physical Medicine and Rehabilitation' },
  { title: 'Podiatry' },
  { title: 'Sleep Medicine' },
  // Add more therapeutic areas as needed
];

const SponsorForm = ({ setShowSpinner }) => {
  const [phase, setPhase] = useState("Phase I");
  const [title, setTitle] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [indication, setIndication] = useState("");
  const [sponsorName, setSponsorName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [activationDate, setActivationDate] = useState(`${new Date().toISOString().slice(0, 10)}`);
  const [closingDate, setClosingDate] = useState(`${new Date().toISOString().slice(0, 10)}`);
  const [CRO, setCRO] = useState("");
  const [criteriaData, setCriteriaData] = useState({ inclusion: '', exclusion: '' });

  const reset = () => {
    setPhase('Phase I');
    setActivationDate('');
    setClosingDate('');
    setCriteriaData({ inclusion: '', exclusion: '' });
  }

  const navigate = useNavigate()
  const handleSubmit = () => {
    setShowSpinner(true);

    const sponsorStudy = {
      phase,
      title,
      therapeuticAreas: selectedArea,
      indication,
      sponsorName,
      email,
      phone,
      activationDate,
      submissionDate: closingDate,
      CRO,
      inclusionCriteria: criteriaData.inclusion,
      exclusionCriteria: criteriaData.exclusion,
    }

    const url = 'https://research-mate-b35a10757d5a.herokuapp.com/api/sponsorStudy/'
    axios.post(url, sponsorStudy)
      .then(res => {
        Swal.fire({
          icon: "success",
          title: "Added...",
          text: res.data.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
        reset()
        navigate('/')
      })
      .catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setShowSpinner(false);
      })
  }

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <div>
      <h4 style={{color:'rgb(23 131 131)'}}>create Study as A Sponsor</h4>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <button className="button" data-text="Awesome" onClick={handleSubmit}>
            <span className="actual-text">&nbsp;Post&nbsp;</span>
            <span aria-hidden="true" className="hover-text">&nbsp;Post&nbsp;</span>
          </button>
        </Box>
      </div>
      <Divider />

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="phase-label">Phase</InputLabel>
            <Select labelId="phase-label" id="phase" value={phase} label="Phase" onChange={e => setPhase(e.target.value)}>
              <MenuItem value={"Phase I"}>Phase I</MenuItem>
              <MenuItem value={"Phase II"}>Phase II</MenuItem>
              <MenuItem value={"Phase III"}>Phase III</MenuItem>
              <MenuItem value={"Phase IV"}>Phase IV</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            defaultValue={activationDate}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
            onChange={e => setActivationDate(e.target.value)}
          />
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            defaultValue={closingDate}
            InputLabelProps={{ shrink: true }}
            onChange={e => setClosingDate(e.target.value)}
          />
        </FormGroup>

        <TextField
          id="input-title"
          label="Title"
          fullWidth sx={{ mt: 2 }}
          onChange={e => setTitle(e.target.value)}
          value={title}
        />

        <Autocomplete
          id="therapeutic-areas"
          options={therapeuticAreas}
          getOptionLabel={(option) => option.title}
          renderInput={(params) => (
            <TextField
              value={selectedArea}
              {...params}
              onBlur={e => setSelectedArea(e.target.value)}
              label="Therapeutic Areas"
              fullWidth
            />)}
          sx={{ mt: 2 }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom', // Ensure menu opens downward
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null, // Prevent menu from being anchored to the input
          }}
        />

        <TextField
          id="indication"
          label="Indication"
          fullWidth sx={{ mt: 2 }}
          onChange={e => setIndication(e.target.value)}
          value={indication}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>
          <TextField
            id="name-sponsors"
            label="Name Sponsors"
            sx={{ mr: 3 }}
            value={sponsorName}
            onChange={e => setSponsorName(e.target.value)}
          />
          <TextField
            id="cro"
            label="CRO"
            sx={{ mr: 3 }}
            value={CRO}
            onChange={e => setCRO(e.target.value)}
          />
          <TextField
            type="email"
            id="Email"
            label="Email"
            sx={{ width: '300px', mr: 3 }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            type="number"
            id="Phone #"
            label="Phone #"
            sx={{ width: '300px' }}
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={criteriaData.inclusion}
            onChange={(e) => setCriteriaData({ ...criteriaData, inclusion: e.target.value })}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={criteriaData.exclusion}
            onChange={(e) => setCriteriaData({ ...criteriaData, exclusion: e.target.value })}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SponsorForm;